import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GroupView } from '@pages/group-detail';

// Typed, shareable search params — the reason we chose TanStack Router (ARCHITECTURE §9).
const searchSchema = z.object({
  tab: z.enum(['expenses', 'balances']).default('expenses'),
});

export const Route = createFileRoute('/_authenticated/groups/$groupId')({
  validateSearch: searchSchema,
  // Show the "My Groups" rail on the right of the group detail (same as the dashboard).
  staticData: { railRight: true },
  // No loader: GroupView reads the selected group from the My Groups list cache (already fetched).
  component: GroupRoute,
});

function GroupRoute() {
  const { groupId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <GroupView groupId={groupId} tab={tab} />;
}
